//@ts-check
import React from 'react';
import Form from '../../../../../form';
import { withStyles, createStyles } from '@material-ui/core';

var styles = function styles(theme) {
  return createStyles(theme.components);
};

var SignatureDialog = function SignatureDialog(_ref) {
  var signature = _ref.signature,
      recipientName = _ref.recipientName,
      recipientRole = _ref.recipientRole,
      onSubmit = _ref.onSubmit,
      onClose = _ref.onClose;

  var onSuccess = function onSuccess(data) {
    onSubmit && onSubmit(data.signature);
    onClose();
  };

  var renderContent = function renderContent(formData) {
    var recipientRole = formData.recipientRole,
        recipientName = formData.recipientName;
    return React.createElement(Form.Fields.Signature, {
      name: "signature",
      valueType: "xmlBase64",
      fullWidth: true,
      injectLabel: false,
      margin: "none",
      recipientRole: recipientRole,
      recipientName: recipientName
    });
  };

  return React.createElement(Form.Dialog, {
    renderContent: renderContent,
    defaultValue: {
      signature: signature,
      recipientRole: recipientRole,
      recipientName: recipientName
    },
    onSuccess: onSuccess,
    onCancel: onClose,
    submitLabel: "Save",
    windowProps: {
      header: "Signature"
    }
  });
};

export default withStyles(styles, {
  withTheme: true,
  name: 'ECSignatureDialog'
})(SignatureDialog);